/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BulkUploadRequestDto } from '../model/bulkUploadRequestDto';
import { ShortCodeModelGenericListResponse } from '../model/shortCodeModelGenericListResponse';
import { ShortCodeModelGenericResponse } from '../model/shortCodeModelGenericResponse';
import { TelcoEnums } from '../model/telcoEnums';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ShortCodeService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param available 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetAllShortCodeByAvailabilityGet(available?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ShortCodeModelGenericListResponse>;
    public apiShortCodeGetAllShortCodeByAvailabilityGet(available?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShortCodeModelGenericListResponse>>;
    public apiShortCodeGetAllShortCodeByAvailabilityGet(available?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShortCodeModelGenericListResponse>>;
    public apiShortCodeGetAllShortCodeByAvailabilityGet(available?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (available !== undefined && available !== null) {
            queryParameters = queryParameters.set('Available', <any>available);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ShortCodeModelGenericListResponse>('get',`${this.basePath}/api/ShortCode/GetAllShortCodeByAvailability`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param telco 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetAllShortCodeByTelcoGet(telco?: TelcoEnums, observe?: 'body', reportProgress?: boolean): Observable<ShortCodeModelGenericListResponse>;
    public apiShortCodeGetAllShortCodeByTelcoGet(telco?: TelcoEnums, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShortCodeModelGenericListResponse>>;
    public apiShortCodeGetAllShortCodeByTelcoGet(telco?: TelcoEnums, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShortCodeModelGenericListResponse>>;
    public apiShortCodeGetAllShortCodeByTelcoGet(telco?: TelcoEnums, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (telco !== undefined && telco !== null) {
            queryParameters = queryParameters.set('telco', <any>telco);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ShortCodeModelGenericListResponse>('get',`${this.basePath}/api/ShortCode/GetAllShortCodeByTelco`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shortCode 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetAllShortCodeGet(shortCode?: string, serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<ShortCodeModelGenericListResponse>;
    public apiShortCodeGetAllShortCodeGet(shortCode?: string, serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShortCodeModelGenericListResponse>>;
    public apiShortCodeGetAllShortCodeGet(shortCode?: string, serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShortCodeModelGenericListResponse>>;
    public apiShortCodeGetAllShortCodeGet(shortCode?: string, serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ShortCodeModelGenericListResponse>('get',`${this.basePath}/api/ShortCode/GetAllShortCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeGetShortCodeIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<ShortCodeModelGenericResponse>;
    public apiShortCodeGetShortCodeIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShortCodeModelGenericResponse>>;
    public apiShortCodeGetShortCodeIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShortCodeModelGenericResponse>>;
    public apiShortCodeGetShortCodeIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiShortCodeGetShortCodeIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ShortCodeModelGenericResponse>('get',`${this.basePath}/api/ShortCode/GetShortCode/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiShortCodeInterShortCodePost(body?: BulkUploadRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ShortCodeModelGenericListResponse>;
    public apiShortCodeInterShortCodePost(body?: BulkUploadRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ShortCodeModelGenericListResponse>>;
    public apiShortCodeInterShortCodePost(body?: BulkUploadRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ShortCodeModelGenericListResponse>>;
    public apiShortCodeInterShortCodePost(body?: BulkUploadRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ShortCodeModelGenericListResponse>('post',`${this.basePath}/api/ShortCode/InterShortCode`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
